(function () {
  'use strict';

  const GIFT_VARIANT_ID = '15327069896994';
  const GIFT_PROPERTY = '_mystery_gift';

  console.log('🎁 Mystery Gift script loaded');

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to retrieve cart');
    }

    return await response.json();
  }

  async function enforceMysteryGift() {
    try {
      const cart = await getCart();

      const giftItems = cart.items.filter(function (item) {
        return String(item.variant_id) === GIFT_VARIANT_ID;
      });

      const normalItems = cart.items.filter(function (item) {
        return String(item.variant_id) !== GIFT_VARIANT_ID;
      });

      /*
       * ==========================================
       * NO NORMAL PRODUCTS
       * ==========================================
       *
       * Remove ALL mystery gifts.
       */
      if (normalItems.length === 0) {

        for (const gift of giftItems) {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: gift.key,
              quantity: 0
            })
          });

        }

        return;
      }


      /*
       * ==========================================
       * NORMAL PRODUCTS EXIST
       * ==========================================
       */

      /*
       * No gift exists → add exactly ONE.
       */
      if (giftItems.length === 0) {

        console.log('🎁 Adding one Mystery Gift');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(GIFT_VARIANT_ID),
                quantity: 1,
                properties: {
                  [GIFT_PROPERTY]: 'true'
                }
              }
            ]
          })
        });

        if (!response.ok) {
          const error = await response.json();
          console.error('Mystery Gift could not be added:', error);
          return;
        }

        window.location.reload();
        return;
      }


      /*
       * ==========================================
       * GIFT ALREADY EXISTS
       * ==========================================
       *
       * Keep ONLY ONE gift line and quantity 1.
       */

      const firstGift = giftItems[0];

      /*
       * Force first gift quantity to 1.
       */
      if (firstGift.quantity !== 1) {

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: firstGift.key,
            quantity: 1
          })
        });

      }


      /*
       * If somehow multiple Mystery Gift lines exist,
       * remove every duplicate.
       */
      if (giftItems.length > 1) {

        console.log(
          '🎁 Removing duplicate Mystery Gifts'
        );

        for (let i = 1; i < giftItems.length; i++) {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: giftItems[i].key,
              quantity: 0
            })
          });

        }

        window.location.reload();
      }

    } catch (error) {

      console.error(
        'Mystery Gift Error:',
        error
      );

    }
  }


  /*
   * ==========================================
   * PRODUCT ADD TO CART
   * ==========================================
   */

  document.addEventListener(
    'submit',
    function (event) {

      const form = event.target;

      if (!form || form.tagName !== 'FORM') {
        return;
      }

      const variantInput = form.querySelector(
        'input[name="id"]'
      );

      if (!variantInput) {
        return;
      }

      setTimeout(
        enforceMysteryGift,
        1200
      );

    },
    true
  );


  /*
   * Catch themes that use AJAX buttons.
   */
  document.addEventListener(
    'click',
    function (event) {

      const button = event.target.closest(
        'button[type="submit"],' +
        'button[name="add"],' +
        '.product-form__submit'
      );

      if (!button) {
        return;
      }

      setTimeout(
        enforceMysteryGift,
        1200
      );

    },
    true
  );


  /*
   * Run once when the page loads.
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      enforceMysteryGift
    );

  } else {

    enforceMysteryGift();

  }

})();